import config from '../data/config.json';
import L from 'leaflet';
import { Datos, Sesion } from '../main.js';

/////////////////
// CÁLCULO CELDAS
// obtengo el lado de cada celda (dependiente del zoom) a partir de la referencia:
// config.degreesStep6 es el número de grados para zoom 6
function getCellSide(zoom) {
	if (!Datos.ladosCeldas[zoom]) {
		const potencia = Math.pow(2, zoom - 6);
		Datos.ladosCeldas[zoom] = config.degreesStep6/potencia;
	}
	return Datos.ladosCeldas[zoom];
}
// a partir de unos bounds genero la malla que lo envuelve para el zoom z
function getGrid(bounds, z) {
	// recupero zoom
	const zoom = z? z : Sesion.zoom;
	// recupero cellSide
	const cellSide = getCellSide(zoom);
	// preparo grid
	const grid = {
		'cellN': Math.floor( bounds.getNorth() / cellSide ),
		'cellS': Math.floor( bounds.getSouth() / cellSide ),
		'cellE': Math.floor( bounds.getEast() / cellSide ),
		'cellW': Math.floor( bounds.getWest() / cellSide )
	};
	// devuelvo grid
	return grid;
}
// los bounds de un grid
function getGridBounds(grid, z) {
	// recupero zoom
	const zoom = z? z : Sesion.zoom;
	// recupero cellSide
	const cellSide = getCellSide(zoom);
	// devuelvo objeto bounds en formato Leaflet
	return L.latLngBounds([
			[ grid.cellS * cellSide, // S
				grid.cellW * cellSide ], // W
			[ (grid.cellN + 1) * cellSide, // N
				(grid.cellE + 1) * cellSide ] // E			
		]);
}
// los bounds de una celda
function getCeldaBounds(cellX, cellY, z) {
	// recupero zoom
	const zoom = z? z : Sesion.zoom;
	// recupero cellSide
	const cellSide = getCellSide(zoom);
	// devuelvo objeto bounds en formato Leaflet
	return L.latLngBounds([
			[ cellY * cellSide, // S
				cellX * cellSide ], // W
			[ (cellY + 1) * cellSide, // N
				(cellX + 1) * cellSide ] // E			
		]);
}
// para una celda dada obtengo el grid para cada nivel de zoom
function getCeldaGridMatrix(cellX, cellY, z, zvalidos) {
	// primero recupero los bounds de la celda
	let bounds = getCeldaBounds(cellX, cellY, z);
	// para evitar el efecto borde, contraigo ligeramente los bounds (1 por diez mil)
	const red = (bounds.getEast() - bounds.getWest())/10000;
	bounds = L.latLngBounds([
			[ bounds.getSouth() + red, // S
				bounds.getWest() + red], // W
			[ bounds.getNorth() - red, // N
				bounds.getEast() - red ] // E
		]);
	// preparo un objeto con el grid para cada nivel de zoom
	let ocgm = {};
	for (let i=config.zMin; i<=config.zMax; i++) {
		if (zvalidos == undefined || zvalidos[i]) // para todos o sólo para los contemplados
			ocgm[i] = getGrid(bounds, i);
	}
	return ocgm;
}


export { getGrid, getGridBounds, getCeldaBounds, getCeldaGridMatrix };